import angular from "angular";

angular
    .module('app')
    .service('Auth', ['AUTH_USER', '$uibModal', '$q', controller]);

function controller(user, $uibModal, $q) {

    let $ctrl = this;

    $ctrl.user = function () {
        return user;
    };

    $ctrl.openLoginModal = function () {
        let d = $q.defer();

        $uibModal
            .open({
                component: 'loginForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    d.resolve(user);
                },
                function (res) {
                    if (res == 'open-register-form') {
                        $ctrl.openRegisterModal().then((user) => d.resolve(user), () => d.reject());
                    } else if (res == 'open-reset-password-form') {
                        $ctrl.openResetPasswordModal().then((user) => d.resolve(user), () => d.reject());
                    } else {
                        d.reject();
                    }
                }
            );

        return d.promise;
    };

    $ctrl.openRegisterModal = function () {
        let d = $q.defer();

        $uibModal
            .open({
                component: 'registerForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    d.resolve(user);
                },
                function (res) {
                    if (res == 'open-login-form') {
                        $ctrl.openLoginModal().then((user) => d.resolve(user), () => d.reject());
                    } else {
                        d.reject();
                    }
                }
            );

        return d.promise;
    };

    $ctrl.openResetPasswordModal = function () {
        let d = $q.defer();

        $uibModal
            .open({
                component: 'resetPasswordForm',
                size: 'auth-form',
                windowTemplateUrl: 'auth-modal-template.html',
                backdrop: 'static'
            })
            .result
            .then(
                function (user) {
                    d.resolve(user);
                },
                function (res) {
                    if (res == 'open-login-form') {
                        $ctrl.openLoginModal().then(() => d.resolve(user), () => d.reject());
                    } else if (res == 'open-register-form') {
                        $ctrl.openRegisterModal().then(() => d.resolve(user), () => d.reject());
                    } else {
                        d.reject();
                    }
                }
            );

        return d.promise;
    };

}
